import { useCallback } from 'react'
import { useMessageFactory } from './messages'

// import { Globals } from '../components/gamePlay/gamingConfigs/diceSession/DiceSession'
// import { MessageFactory } from './messages'
import { Protocol, ErrorTypes, Status } from '../library/constants'
import GameUtils from './gameutils'
import { handleErrors } from './handleErrors'
// import { MessagesList } from './plinko_msg'

// import { objToStringSettings } from '../components/settings/saveSettings/objToStringSettings'
import useSenders from './useSenders'
import { logger } from 'functions/logger/logger'

export const useSocketMessages = ({
  socket,
  MessagesList,
  setbetInfo,
  setgameInfo,
  addInHistory,
  setSeeds,
  setBetReply,
  handleNotification,
  setStateRound,
  handleErrorText,
  receiveSettings,
  setErrorCode,
  setStats,
  roundState,
  roundUpdate,
  roundUserUpdate,
  placeBet,
  cancelBet,
  placeBetResponce,
  cashout,
  cashoutResponce,
  updateBalanceResponce,
  name,
  setFullRoundResponce,
  setJackpotInfo,
  setJackpotWin,
  setAirdrop,
}: any) => {
  const [parseMessage, createMessage] = useMessageFactory(MessagesList)

  const setStatus = useCallback(
    status => {
      logger.log('%cstatus = ', 'color:brown', status)
      const session = GameUtils.getParameterByName('session')
      switch (status) {
        case Status.CONNECTED:
          logger.log('%cconnected ', 'color:green')
          // this.setState({ noSignal: false });

          if (typeof session === 'string') {
            const loginMsg = name
              ? createMessage(Protocol.LOGIN, session + '@1', name)
              : createMessage(Protocol.LOGIN, session + '@1')

            socket.current && socket.current.sendMessage(loginMsg)
          } else {
            // TODO : not logged in error page or notification
            console.error('not logged in ' + status)
          }

          break
        case Status.DISCONNECTED:
          console.error('%cdisconnected ', 'color:brown')
          handleErrors('', handleErrorText, handleNotification)

          // handleErrorText('Cannot connect')
          // this.setState({
          //   popup: true,
          //   isAutoOn: false,
          //   noSignal: true,
          //   // notifyMSG: false,
          // });

          // clearTimeout(this.myTimeout);
          // clearTimeout(this.notificationTimeOut);
          break
        default:
          break
      }
    },
    [createMessage, socket],
  )
  const doMessage = useCallback(
    msg => {
      let msgObject: any = null
      try {
        msgObject = parseMessage(msg)
      } catch (e) {
        console.dir(e)
      }

      if (msgObject === null) {
        // error unknown message
        logger.log('doMessage msgObject === null ', msg)
        return
      }

      switch (msgObject.type) {
        case Protocol.BET_INFO_RESPONCE:
          logger.log('%cBET_INFO_RESPONCE', 'color:aqua', msgObject)
          return setbetInfo(msgObject)
        case Protocol.GAME_STATE:
          logger.log('%cGAME_STATE', 'color:aqua', msgObject)
          return setgameInfo(msgObject)
        case Protocol.STATE_ROUND:
          logger.log('%cSTATE_ROUND', 'color:aqua', msgObject)
          return setStateRound(msgObject)
        case Protocol.HISTORY:
          // logger.log('%cHISTORY', 'color:aqua', msgObject)
          return addInHistory(msgObject)
        case Protocol.USER_SETTINGS_RESPONCE:
          logger.log('%cUSER_SETTINGS_RESPONCE', 'color:aqua', msgObject)
          return receiveSettings(msgObject.settings)
        case Protocol.GET_SEEDS_RESPONCE:
          logger.log('%cGET_SEEDS_RESPONCE', 'color:aqua', msgObject)
          return setSeeds(msgObject)
        case Protocol.GET_ROUND_RESPONCE:
          logger.log('%cGET_ROUND_RESPONCE', 'color:aqua', msgObject)
          return setBetReply(msgObject)
        case Protocol.GET_STATS_RESPONCE:
          logger.log('%cGET_STATS_RESPONCE', 'color:aqua', msgObject)
          return setStats(msgObject)
        case Protocol.ROUND_STATE:
          logger.log('%cROUND_STATE', 'color:aqua', msgObject)
          return roundState(msgObject)
        case Protocol.ROUND_UPDATE:
          // logger.log('%cROUND_UPDATE', 'color:aqua', msgObject)
          return roundUpdate(msgObject)
        case Protocol.ROUND_USER_UPDATE:
          logger.log('%cROUND_USER_UPDATE', 'color:aqua', msgObject)
          return roundUserUpdate(msgObject)
        case Protocol.PLACE_BET:
          logger.log('%cPLACE_BET', 'color:aqua', msgObject)
          return placeBet(msgObject)
        case Protocol.CANCEL_BET:
          logger.log('%cCANCEL_BET', 'color:aqua', msgObject)
          return cancelBet(msgObject)
        case Protocol.PLACE_BET_RESPONCE:
          logger.log('%cPLACE_BET_RESPONCE', 'color:aqua', msgObject)
          return placeBetResponce(msgObject)
        case Protocol.CASHOUT:
          logger.log('%cCASHOUT', 'color:aqua', msgObject)
          return cashout(msgObject)
        case Protocol.CASHOUT_RESPONCE:
          logger.log('%cCASHOUT_RESPONCE', 'color:aqua', msgObject)
          return cashoutResponce(msgObject)
        case Protocol.UPDATE_BALANCE_RESPONCE:
          logger.log('%cUPDATE_BALANCE_RESPONCE', 'color:aqua', msgObject)
          return updateBalanceResponce(msgObject)
        case Protocol.FULLROUNDRESPONCE:
          logger.log('%cFULLROUNDRESPONCE', 'color:aqua', msgObject)
          return setFullRoundResponce(msgObject)
        case Protocol.JACKPOT_INFO:
          logger.log('%cJACKPOT_INFO', 'color:aqua', msgObject)
          return setJackpotInfo(msgObject)
        case Protocol.JACKPOT_WIN:
          logger.log('%cJACKPOT_WIN', 'color:aqua', msgObject)
          return setJackpotWin(msgObject)
        case Protocol.AIRDROP:
          logger.log('%cAIRDROP', 'color:aqua', msgObject)
          return setAirdrop(msgObject)
        case Protocol.PING:
          logger.log('%cPING', 'color:aqua', msgObject)
          return
        case Protocol.ERROR:
          // logger.error('%cERROR', 'color:aqua', msgObject)
          handleErrors(msgObject.errorCode, handleErrorText, handleNotification)
          setErrorCode(msgObject.errorCode)
          break
        default:
          console.error(
            'doMessage switch default case ',
            msgObject,
            ErrorTypes[msgObject.errorCode?.toString()],
          )

          break
      }
    },
    [parseMessage, setgameInfo],
  )

  const sendSocketMessage = (...args: any[]) => {
    const message = createMessage(...args)
    if (socket.current) {
      return socket.current.sendMessage(message)
    }
  }

  const sender = useSenders(sendSocketMessage)
  return [setStatus, doMessage, sendSocketMessage, sender]
}
